export default __webpack_public_path__ + "static/google-play-badge-da2cba2a3dbcd207a02b0cf0c3b3234d.svg";